export default __webpack_public_path__ + "static/media/addProjects.10f89cec.png";